import { Module } from 'vuex';

export interface Device {
  id: number | null,
  created_at: string | null,
  updated_at: string | null,
  mac_address: string | null,
  policy_id: number | null,
  profile_id: number | null,
  network_id: number | null,
  name: string | null,
  brand: string | null,
}
const defaultState: Device = {
  id: null,
  created_at: "",
  updated_at: "",
  mac_address: "",
  policy_id: null,
  profile_id: null,
  network_id: null,
  name: null,
  brand: null,
};

const deviceStore: Module<Device, {}> = {
  state: defaultState,
  mutations: {
    saveDetails(state, device: { id: number; name: string; brand: string; mac_address: string; profile_id: number;  network_id: number; policy_id: number; created_at: string; updated_at: string; }) {
      state.id = device.id;
      state.mac_address = device.mac_address;
      state.policy_id = device.policy_id;
      state.profile_id = device.profile_id;
      state.network_id = device.network_id;
      state.created_at = device.created_at;
      state.updated_at = device.updated_at;
      state.name = device.name;
      state.brand = device.brand;
    }
  },
  actions: {
    saveDetails({ commit }, device: { id: number; name: string; brand: string; mac_address: string; profile_id: number;  network_id: number; policy_id: number; created_at: string; updated_at: string; }) {
      // setTimeout(() => {
        commit('saveDetails', device);
      // }, 50);
    }
  }
};

export default deviceStore;
